import { useEffect, useState } from "react";
import RenderMovies from './RenderMovies.js';
import './style.css';
import SearchingNavbar from "./SearchingNavbar.js";

export default function Explore() {
    
    const [input, setInput] = useState('');
    const [doesExist, setDoesExist] = useState(true);
    const [cache, setCache] = useState([]);
    const [counter, setCounter] = useState(0);
    const [hide, setHide] = useState(true);

    function fetchData(url) {
        return fetch(url)
        .then((result) => result.json());
    }
    
    //parseInput splits the input on the space and then rejoins it with + instead
    function parseInput() {
        let wordArray= input.split(' ');
        let queryString = wordArray.join('+');
        return queryString
    }
    const searchRequest = async (searchData) => {
        //variables
        const searchMethod = `https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_TMDB_API_KEY}&query=`;
        let query = parseInput(searchData);
        let fullSearch = searchMethod + query;

        //send api request and wait for response
        const response = await fetchData(fullSearch);
        //test to see if any results were returned
        if (response.results.length === 0) {
            setDoesExist(false);
        } else {
            const copy = [];
            let i = 0;
            while (i < response.results.length) {
                const currentSearch = [];
                let count = 0;
                while(count < 4 && i < response.results.length) {
                    if (response.results[i].poster_path === null) {
                        i++;
                    } else {
                        currentSearch.push(response.results[i]);
                        count++;
                        i++;
                    }
                }
                copy.push(currentSearch);
            }
            setCache([...cache, copy]);
            setCounter(counter + 1);
            setDoesExist(true);
            setHide(false);
            //setTimeout to bring up load graphic for 3 seconds...
            setTimeout(() =>{
                setHide(true)
            }, 1700);
        }
    }
    function checkIfRender() {
        return <RenderMovies counter={counter} cache={cache} />
    }

    function isLoaderHidden() {
        //function that determines what css to render for modal visibility property
        if (hide) {
            const modalStyle = {
                visibility: 'hidden'
            }
            return modalStyle;
        } else {
            const modalStyle = {
                visibility: 'visible'
            }
            return modalStyle;
        }
    }
    return (
        <div className="main-content">
            <div className="loader-container bg-white" style={isLoaderHidden()}>
                <div className="loader"></div>
                <div className="text-white fs-2">Loading...</div>
            </div>
            <nav className="MApp-toolbar bg-primary">
                <h1 className="text-white ps-5">MApp</h1>
                <div className="logo ps-4 ms-4 mt-3">
                    <h3 className="text-white">The Movie App</h3>
                    <i className="fa-regular fa-map"></i>
                </div>
                
                <div className="search-bar">
                    <label className="me-1 text-white" htmlFor="">Search</label>
                    <input className="search-box bg-dark text-white" type="text" onChange={(e) => setInput(e.target.value)} onKeyUp={e => e.key === 'Enter' ? searchRequest() : null} />
                </div>
            </nav> 
            <div className="landing-page search">  
                
                {!doesExist && (
                    <div className="output">
                        The search yielded no results. Please try again.
                    </div>
                )}
                {checkIfRender()}
                {/* <div className="flex bg-dark justify-content-center w-100 movie-pic"></div> */}
                {/* {console.log("Items in the cache: ", cache)} */}
            </div>
        </div>
    )
}